<template>
    <div>
        <!--新增-->
        <div class="tool_head">
          <el-button type="success" icon="el-icon-circle-plus-outline" @click="addClick" round>添加</el-button>
        </div>
        <DxDataGrid
                class="dx-card wide-card"
                :data-source="dataSource"
                :focused-row-index="0"
                :show-borders="true"
                :focused-row-enabled="true"
                :column-auto-width="true"
                :column-hiding-enabled="true"
                :ref="dataGridRefKey"
                @row-updated="logEvent('RowUpdated')"
                key-expr="marketingId"
        >
            <!--加载框-->
            <DxLoadPanel :enabled="true" />
            <dx-paging :page-size="10" />
            <dx-pager :show-page-size-selector="true" :show-info="true" />
            <dx-filter-row :visible="true" /><!--列过滤-->
            <DxColumn
                    data-field="wechatName"
                    caption="公众号"
                    data-type="string"
                    :hiding-priority="8"
            />
            <DxColumn
                    data-field="sendCount"
                    caption="推送次数"
                    data-type="string"
                    :hiding-priority="3"
            />
            <DxColumn
                    data-field="carete_time"
                    caption="创建时间"
                    data-type="date"
                    :hiding-priority="3"
            />


            <DxColumn  type="buttons" :width="125" >
                <DxTextBoxButton
                        hint="列表"
                        icon="menu"
                        :visible="true"
                        :disabled="false"
                        :on-click="redirectInfo"
                        :width="125"
                />
<!--                <DxTextBoxButton-->
<!--                        hint="修改"-->
<!--                        icon="edit"-->
<!--                        :visible="true"-->
<!--                        :disabled="false"-->
<!--                        :on-click="modifyInfo"-->
<!--                        :width="125"-->
<!--                />-->
            </DxColumn>
        </DxDataGrid>

        <!--新增营销信息-->
        <DxPopup
                target="addMarketing"
                :maxWidth="660"
                :minHeight="700"
                :visible="popupVisible"
                show-event="dxhoverstart"
                hide-event="dxhoverend"
                :resize-enabled="true"
        >
            <template #content="{ data }">
                <div class="popup-property-details">
                    <DxScrollView
                            :height="500"
                            :width="600"
                            direction="both">

                        <!--发送消息-->
                        <marketingMessage  @closeProp="closeProp" :type="type"
                        ></marketingMessage>

                    </DxScrollView>

                </div>
            </template>


            <DxToolbarItem widget="dxButton" toolbar="bottom" location="after"  :options="closeButtonOptions"></DxToolbarItem>

        </DxPopup>


        <!--新增营销信息-->
        <DxPopup
                target="addMarketing"
                :maxWidth="660"
                :minHeight="700"
                :visible="popupVisibleModify"
                show-event="dxhoverstart"
                hide-event="dxhoverend"
                :resize-enabled="true"
        >
            <template #content="{ data }">
                <div class="popup-property-details">
                    <DxScrollView
                            :height="500"
                            :width="600"
                            direction="both">

                        <!--发送消息-->
                        <modifyMessage  @closeProp="closeProp" :activity="activity"
                        ></modifyMessage>

                    </DxScrollView>

                </div>
            </template>


            <DxToolbarItem widget="dxButton" toolbar="bottom" location="after"  :options="closeButtonOptions"></DxToolbarItem>

        </DxPopup>

    </div>
</template>
<script src="../../../css/my_styles.css"></script>
<script>

    import {DxDataGrid,DxColumn,DxButton as DxTextBoxButton } from 'devextreme-vue/data-grid';
    import { DxScrollView } from 'devextreme-vue/scroll-view';
    import marketingMessage from "../../../components/marketing_message";
    import modifyMessage from "../../../components/message_modify";

    import {
        DxFileUploader
    } from 'devextreme-vue/file-uploader';

    const dataGridRefKey = 'myDataGrid';

    export default {
        /*营销列表*/
        name: "marketingList",
        components: {
            DxScrollView,
            DxFileUploader,
            DxDataGrid,
            DxColumn,
            DxTextBoxButton,
            marketingMessage,
            modifyMessage
        },
        data(){
            return{
                type:"birthday",
                dataGridRefKey,
                dataSource:[],
                events: [],
                popupVisible : false,
                popupVisibleModify:false,
                closeButtonOptions: {
                    text: 'Close',
                    onClick: () => {
                        this.popupVisible = false;
                        this.popupVisibleModify = false;
                    },
                },
                formData:{},
                wechatSelect:[ { id: 1, country: "产品" },
                    { id: 2, country: "活动" }],
                wechatNameSelect:[],
                modeSelect:[],
                files: [],
                marketingType:new Object(),
                wxId:new Object(),
                activity:{}
            }
        },
        created() {
            this.getData()

        },
        onLoad(){

        },
        computed: {
            dataGrid: function() {
                return this.$refs[dataGridRefKey].instance;
            }
        },
        methods:{
            redirectInfo(e){
                this.$router.push({
                    path:'/marketingInfo',
                    query:{
                        "marketingId":e.row.data.marketingId
                    }
                })
            },
            modifyInfo(e){
                this.activity = e.row.data
                this.popupVisibleModify = true;
            },
            fileUploader_abortUpload(file,uploadInfo){
                //console.log(file)
                //console.log(uploadInfo)
            },
            getData(){
                this.$http.get_marketing_list({"type" : 1}).then(res => {
                    if(res.status == "success"){
                        this.dataSource=res.data
                    }

                })
            },
            logEvent(eventName) {
                //console.log(eventName)
                switch (eventName) {
                    case "RowUpdated":
                        //console.log("进行更新操作")
                        break;
                }
            },
            addClick(){
                this.popupVisible = true;
                /*获取微信公众号信息*/
                this.$http.get_wxconfig(null).then(res=>{
                    this.wechatNameSelect = res.data
                })

            },
            submitFrom(){
                // //console.log(this.formData)
                // this.$http.upload_img(this.files[0]).then(res =>{
                //     //console.log(res)
                // })
                //
                // return ;
                const param =this.formData
                param.wxId = this.wxId
                param.marketingType = this.marketingType
                // param.marketingBk = this.files[0]


                //console.log(param)

                this.$http.add_marketing_model(param).then(res=>{
                    //console.log(res)
                    if(res.status == "success"){
                        this.getData()
                        this.popupVisible = false;
                    }
                })

            },
            changeWechatBox(e){
                this.wxId = e.value
                //查找模板
                //根据微信公众号获取所有的模板
                this.$http.get_template_all({"appId":e.value}).then(res =>{
                    this.modeSelect =res.data
                })
            },
            changeTypeBox(e){
                this.marketingType = e.value
            },
            changeModeltBox(e){
                //console.log(e)
            },
            closeProp(){
                this.popupVisible = false
                this.popupVisibleModify = false;
                this.getData()
            }
        }
    }
</script>

<style scoped>

</style>